// native
import { NgModule } from "@angular/core";

// module
import { SharedModule } from "../shared/shared.module";

// component
import { DemoComponent } from "./demo/demo.component";

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    DemoComponent
  ]
})
export class DemoModule { }